<script setup lang="ts">
import { ref, onMounted, onUnmounted, computed } from 'vue';
import { useAuthStore } from './stores/auth';
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';

const authStore = useAuthStore();

// Show test banner only when explicitly enabled (staging only)
const isTestMode = computed(() => {
  return import.meta.env.VITE_SHOW_TEST_BANNER === 'true';
});

// Reactive online status
const isOnline = ref(navigator.onLine);

function handleOnline() {
  isOnline.value = true;
}

function handleOffline() {
  isOnline.value = false;
}

onMounted(async () => {
  window.addEventListener('online', handleOnline);
  window.addEventListener('offline', handleOffline);
  await authStore.initialize();
});

onUnmounted(() => {
  window.removeEventListener('online', handleOnline);
  window.removeEventListener('offline', handleOffline);
});
</script>

<template>
  <div class="app-container">
    <!-- Test Mode Banner -->
    <div v-if="isTestMode" class="test-mode-banner">
      ⚠️ TEST MODE - Payments are simulated
    </div>
    
    <!-- Offline Banner -->
    <div v-if="!isOnline" class="offline-banner">
      📡 You are offline. Some features may not work.
    </div>
    
    <router-view />
    
    <Toast position="top-right" />
    <ConfirmDialog />
  </div>
</template>

<style scoped>
.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--surface-ground);
}

.test-mode-banner {
  background: rgba(245, 158, 11, 0.15);
  color: #fbbf24;
  text-align: center;
  padding: 8px;
  font-weight: 600;
  font-size: 14px;
  border-bottom: 1px solid rgba(245, 158, 11, 0.3);
}

.offline-banner {
  background: rgba(239, 68, 68, 0.15);
  color: #f87171;
  text-align: center;
  padding: 8px;
  font-weight: 600;
  font-size: 14px;
  border-bottom: 1px solid rgba(239, 68, 68, 0.3);
}
</style>
